module.exports = __webpack_public_path__ + "static/media/attachment.57603bc7.svg";